import { z } from "zod";
export const ScrapeUrlRequestSchema = z.object({
    url: z.string().url().max(2048),
    downloadImage: z.boolean().default(false),
});
export const ScrapeUrlResponseSchema = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    imageUrl: z.string().optional(),
});
